import IconBase, { type IconProps } from '@yoweb/ui/components/Icon/IconBase';

export const HomePageFilledIcon = (props: IconProps) => (
  <IconBase viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.43 2.386a.75.75 0 0 0-.86 0l-7.987 5.59a.76.76 0 0 0-.025.018L1.57 9.386a.75.75 0 1 0 .86 1.228l.82-.574V21c0 .414.336.75.75.75h16a.75.75 0 0 0 .75-.75V10.04l.82.574a.75.75 0 1 0 .86-1.228L20.438 7.99l-.017-.012-7.99-5.593ZM14.25 20.5h-4.5V15c0-.69.56-1.25 1.25-1.25h2c.69 0 1.25.56 1.25 1.25v5.5Z"
      clipRule="evenodd"
    />
  </IconBase>
);

export default HomePageFilledIcon;
